import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import axios from 'axios';
import VueAxios from 'vue-axios';
import i18n from "./i18n";

axios.interceptors.response.use(function (res) {
    console.log(res);
    return res;
  }, function (error) {
    console.log(error)
  });

createApp(App).use(i18n).use(store).use(VueAxios, axios).mount('#app')
